import { client, clientWithoutErrorHandling } from '../http';

export default {
  async createSubscription(token, card, iterationType) {
    const response = await clientWithoutErrorHandling.post('/api/subscribe', { token, card, iterationType });
    return response.data;
  },

  async createMoneyBackSubscription(token, card) {
    const response = await clientWithoutErrorHandling.post('/api/subscribe/money-back-guarantee', { token, card });
    return response.data;
  },

  async purchaseGiftcard(token, email) {
    const response = await clientWithoutErrorHandling.post('/api/sale', { token, email, productType: 'GIFTCARD' });
    return response.data;
  },

  async updateCreditCard(token, card) {
    const response = await clientWithoutErrorHandling.post('/api/update-credit-card', { token, card });
    return response.data;
  },

  async getCreditCardDetails() {
    const response = await client.get('/api/credit-card-details');
    return response.data;
  },

  async getSubscription() {
    const response = await clientWithoutErrorHandling.get('/api/latest-subscription');
    return response.data;
  },

  async fetchPricingOption() {
    const response = await client.get('/api/pricing-options');
    return response.data;
  },

  async eligibleForAnnualSubscription() {
    const response = await client.get('/api/eligible-for-annual-subscription');
    return response.data;
  },
};
